import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

interface Props {
    to: string;
}

export function TextLink({ to, children }: PropsWithChildren<Props>) {
    return <Link className="linkOnBlack" to={to}>{children}</Link>
}